export default __webpack_public_path__ + "static/image-6-811ec1bf79253d3122625e6669d9afcd.png";